import * as React from "react";

const IconPaginationArrowDownSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12">
            <polygon fill="currentColor" points="16 6 4 16 4 -4" transform="rotate(90 10 6)" />
        </svg>
    );
};

export default React.memo(IconPaginationArrowDownSmall);
